import $ from 'jquery';

import webApp from './webApp';

var APP_TYPE = 'webapp';

var blogId = 0;
var trackingId = null;
var gtmId = null;
var clientId = null;
var initialized = false;
var userType = null;
var dimAppType = 1;
var dimUserType = 2;
var dimIssue = 3;
var dimArticle = 4;
var dimIssuePrice = 5;
var dimIssueTags = 6;
var eventCache = [];

function initDataFromServer() {

  $.ajax( {
    url: webApp.env.site_url +'/asmag/web-app/analytics/init',
    dataType: 'json',
    timeout: 5000
  } ).
    done( function( data ) {
      if ( initialized ) {
        return;
      }

      if ( data && data.code === 0 ) {

        trackingId = data.result.trackingId;
        gtmId = data.result.gtmId;
        // User type: subscriber/nonsubscriber/notloggedin
        userType = data.result.userType;
        // Custom dimensions
        dimAppType = data.result.dimAppType;
        dimUserType = data.result.dimUserType;
        dimIssue = data.result.dimIssue;
        dimArticle = data.result.dimArticle;
        dimIssuePrice = data.result.dimIssuePrice;
        dimIssueTags = data.result.dimIssueTags;

        if ( gtmId ) {
          // If a GTM ID has been defined, we disable Asteikko Mag's GA tracking
          // snippet fully. No data will be sent to GA by Asteikko Mag's
          // asteikkoGA() function, and instead we assume that the GTM script
          // (that is automatically added to <head> by Asteikko Mag when
          // a GTM ID exists) sends data to GA itself.
          trackingId = null;
        }

        if ( trackingId ) {
          window.asteikkoGA( 'create', trackingId, {
            name: 'asteikkomag',
            cookieDomain: data.result.cookieDomain || 'auto',
            // GDPR support. Don't store cookies, and anonymize IPs.
            // Note that `storage: 'none'` will not store a unique ID for
            // the browser, and therefore if the user reloads the browser page
            // he will end up being counted as a _new_ user in Google Analytics.
            // You can see this if you go to the realtime view in GA and reload
            // the Asteikko Mag issue reading view browser page multiple times.
            // The result is that the GA realtime view will show multiple users
            // (one user per browser page reload).
            storage: 'none',
            anonymizeIp: true
          } );
          window.asteikkoGA( onInitGA );
        }
        // No GA tracking ID, so we're never gonna send analytics to GA
        else {
          eventCache.length = 0;
        }
      }
    } ).
    always( function() {
      initialized = true;
      purgeEventCache();
    } );
}

function purgeEventCache() {

  if ( !initialized || !eventCache.length || !webApp.networkStatus || !window.asteikkoGA ) {
    return;
  }

  var sentEvent = eventCache.shift();

  // Assign custom dim values to correct indices
  sentEvent.data[ 'dimension'+ dimAppType ] = APP_TYPE;
  if ( userType ) sentEvent.data[ 'dimension'+ dimUserType ] = userType;
  if ( sentEvent.issue ) sentEvent.data[ 'dimension'+ dimIssue ] = sentEvent.issue;
  if ( sentEvent.article ) sentEvent.data[ 'dimension'+ dimArticle ] = sentEvent.article;
  if ( sentEvent.issuePrice ) sentEvent.data[ 'dimension'+ dimIssuePrice ] = sentEvent.issuePrice;
  if ( sentEvent.issueTags ) sentEvent.data[ 'dimension'+ dimIssueTags ] = sentEvent.issueTags;

  // Set the Queue Time parameter to account for the offset between recorded and sent time
  sentEvent.data.queueTime = ( new Date() ).getTime() - sentEvent.origTime;
  window.asteikkoGA( 'asteikkomag.send', sentEvent.data );
  webApp.console.log( 'Sent cached event of type "'+ sentEvent.data.hitType +'"' );
  webApp.console.log( 'Events left: '+ eventCache.length );

  // Make sure we don't exceed the analytics.js hit limit:
  // "Each web property starts with 20 hits that are replenished at a rate 
  // of 2 hit per second"
  if ( eventCache.length ) window.setTimeout( purgeEventCache, 1000 );
}

function onConnectivityChange( isOnline ) {
  if ( isOnline ) {
    purgeEventCache();
  }
}

function onInitGA() {
  var tracker = window.asteikkoGA.getByName( 'asteikkomag' );
  clientId = tracker.get( 'clientId' );
  purgeEventCache();
}


const analytics = {};

analytics.init = function( app ) {

  if ( initialized || window.asteikkoGA ) return;

  blogId = webApp.env.blog_id;

  /* jshint ignore:start */
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','asteikkoGA');
  /* jshint ignore:end */

  this.initIssueReaderHooks();
  $( initDataFromServer );
  webApp.hooks.addAction( 'network_status_changed', 'analytics', onConnectivityChange );
};

analytics.getAppTypeDim = function() { return dimAppType; };
analytics.getUserTypeDim = function() { return dimUserType; };
analytics.getIssueDim = function() { return dimIssue; };
analytics.getArticleDim = function() { return dimArticle; };
analytics.getIssuePriceDim = function() { return dimIssuePrice; };
analytics.getIssueTagsDim = function() { return dimIssueTags; };

/**
 * issueTags should be string of comma-separated tags.
 */
analytics.sendEvent = function( category, action, label, value, issue, article, issuePrice, issueTags ) {

  if ( !window.asteikkoGA || ( initialized && !trackingId ) ) return;

  var data = {
    'hitType': 'event',
    'eventCategory': category,
    'eventAction': action,
    'eventLabel': label,
    'eventValue': value
  };

  if ( initialized && webApp.networkStatus ) {

    // Set up custom dimensions
    data[ 'dimension'+ dimAppType ] = APP_TYPE;
    if ( userType ) data[ 'dimension'+ dimUserType ] = userType;
    if ( issue ) data[ 'dimension'+ dimIssue ] = issue;
    if ( article ) data[ 'dimension'+ dimArticle ] = article;
    if ( issuePrice ) data[ 'dimension'+ dimIssuePrice ] = issuePrice;
    if ( issueTags ) data[ 'dimension'+ dimIssueTags ] = issueTags;

    window.asteikkoGA( 'asteikkomag.send', data );
  }
  else {

    webApp.console.log( 'Caching sendEvent' );
    eventCache.push( {
      origTime: ( new Date() ).getTime(),
      data: data,
      issue: issue,
      article: article,
      issuePrice: issuePrice,
      issueTags: issueTags
    } );
  }
};

/**
 * issueTags should be string of comma-separated tags.
 */
analytics.sendPageView = function( page, title, issue, article, issuePrice, issueTags ) {

  if ( !window.asteikkoGA || ( initialized && !trackingId ) ) return;

  var data = {
    'hitType': 'pageview'
  };

  if ( page ) data.page = page;
  if ( title ) data.title = title;

  if ( initialized && webApp.networkStatus ) {

    // Set up custom dimensions
    data[ 'dimension'+ dimAppType ] = APP_TYPE;
    if ( userType ) data[ 'dimension'+ dimUserType ] = userType;
    if ( issue ) data[ 'dimension'+ dimIssue ] = issue;
    if ( article ) data[ 'dimension'+ dimArticle ] = article;
    if ( issuePrice ) data[ 'dimension'+ dimIssuePrice ] = issuePrice;
    if ( issueTags ) data[ 'dimension'+ dimIssueTags ] = issueTags;

    window.asteikkoGA( 'asteikkomag.send', data );
  }
  else {

    webApp.console.log( 'Caching sendPageView' );
    eventCache.push( {
      origTime: ( new Date() ).getTime(),
      data: data,
      issue: issue,
      article: article,
      issuePrice: issuePrice,
      issueTags: issueTags
    } );
  }
};

// TODO: save to cache and purge when initialized/online like with sendPageView
analytics.sendToMeasurementProt = function( data, synchronous ) {

  if ( !window.asteikkoGA || ( initialized && !trackingId ) ) return;

  data.cid = clientId;
  data.asmag_blogid = blogId;

  $.ajax( webApp.env.plugin_url + '/shortinit/analytics-collect', {
    async: !synchronous,
    type: 'POST',
    data: data,
    timeout: 2000
  } );
};

analytics.initIssueReaderHooks = function() {

  webApp.hooks.removeAction( 'reader_opened', 'asmag_analytics' );
  webApp.hooks.addAction( 'reader_opened', 'asmag_analytics', ( issue, initialPageIndex ) => {

    analytics.sendEvent(
      'AsteikkoMag', 
      'Open issue', 
      issue.slug,
      undefined, 
      issue.id, 
      undefined, 
      issue.paid ? 'paid' : 'free',
      issue.tags.join( ',' )
    );

    // Fire pageview event for the initial page
    if ( issue.pages[initialPageIndex] ) {

      var path = issue.pages[initialPageIndex].permalink.replace( /^.+?:\/\/[^\/]+/, '' );

      analytics.sendPageView( 
        path,
        issue.name +': '+ issue.pages[initialPageIndex].title,
        issue.id, 
        issue.pages[initialPageIndex].id,
        issue.paid ? 'paid' : 'free',
        issue.tags.join( ',' )
      );
    }
  } );

  webApp.hooks.removeAction( 'reader_closed', 'asmag_analytics' );
  webApp.hooks.addAction( 'reader_closed', 'asmag_analytics', ( issue, initialPageIndex ) => {
    analytics.sendToMeasurementProt( {
      t: 'pageview',
      dp: '/asmag/exit',
      dt: 'Close digimag'
    } );
  } );

  webApp.hooks.removeAction( 'reader_page_index_changed', 'asmag_analytics' );
  webApp.hooks.addAction( 'reader_page_index_changed', 'asmag_analytics', ( oldIndex, currentIndex, oldPage, currentPage ) => {

    if ( !webApp.issueReader.issue )
      return;

    const path = currentPage.permalink.replace( /^.+?:\/\/[^\/]+/, '' );

    analytics.sendPageView( 
      path,
      webApp.issueReader.issue.name +': '+ currentPage.title,
      webApp.issueReader.issue.id, 
      currentPage.id,
      webApp.issueReader.issue.paid ? 'paid' : 'free',
      webApp.issueReader.issue.tags.join( ',' )
    );

  } );

  $( window ).off( 'beforeunload.asmag_analytics' );
  $( window ).on( 'beforeunload.asmag_analytics', () => {

    if ( !webApp.issueReader.issue )
      return;

    // Synchronous request to block the browser before closing the window to 
    // make sure the request succeeds
    analytics.sendToMeasurementProt( {
      t: 'pageview',
      dp: '/asmag/exit',
      dt: 'Close digimag'
    }, true );
  } );
};

export default analytics;
